<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <Pre-page :nav="prePageNav"></Pre-page>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="main-container">
              <div class="crop-title">
                {{ cropObject.cropName + cropObject.name }}
              </div>
              <div class="crop-infos">
                <div class="crop-info-item">
                  <span>类别：{{ cropObject.cropName }}</span>
                </div>
                <div class="crop-info-item">
                  <span>日期：{{ cropObject.createTime | timeAgo }}</span>
                </div>
                <div class="crop-info-item">
                  <span>浏览量：{{ cropObject.virtualViews }}</span>
                </div>
              </div>
              <OneTitle :title="'症状'"></OneTitle>
              <div class="crop-t">
                <CropCard :card="grow"></CropCard>
              </div>
              <OneTitle :title="'防治建议'"></OneTitle>
              <div class="crop-times">
                <CropCard :card="disease"></CropCard>
              </div>
            </div>
            <AboutResearch
              style="margin-bottom: 40px"
              :list="aboutR"
              :type='2'
            ></AboutResearch>
          </div>

          <div class="likeList">
            <Like :list="cardList"></Like>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Like from "../components/likeList.vue";
import PrePage from "../components/PrePage.vue";
import OneTitle from "../components/OneTitle.vue";
import CropCard from "../components/CropCard.vue";
import AboutResearch from "../components/aboutResearch.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CropCard,
    Like,
    PrePage,
    OneTitle,
    AboutResearch,
  },
  data: () => {
    return {
      totalpage: 10,
      currentpage: 1,
      loading: false,
      cropObject: {},
      crop: {},
      cardType: "0", //0 农技文章
      research: {
        createTime: "",
      },
      comments: [],
      prePageNav: [
        {
          name: "首页",
          to: "/",
        },
        {
          name: "病虫害图谱",
          to: "bch.html",
        },
        {
          name: "小麦专区",
          to: "bch.html?id=1",
        },
        {
          name: "详情",
          to: "",
        },
      ],
      cardList: [
        {
          title: "",
          desc: "",
          author: "",
          time: "",
          clickViews: 10,
          imgUrl: "",
        },
      ],
      id: "",
      grow: {},
      disease: {},
      aboutR: [],
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    this.id = gus.id;

    this.$axios
      .get(
        `https://m.nongjike.cn/app/community/pdGalleryDetail?galleryId=${gus.id}&userId=1234`
      )
      .then((res) => {
        console.log(res);
        let data = res.data.information;
        this.prePageNav[2] = {
          to: `bch.html?id=${data.cropId}`,
          name: `${data.cropName}专区`,
        };
        this.grow = [
          {
            name: "简介",
            text: data.synopsis,
          },
          {
            name: "发生周期",
            text: data.onsetTime,
          },
          {
            name: "发生原因",
            text: data.onsetCause,
          },
          {
            name: "发生症状",
            text: data.onsetSymptom,
          },
          {
            name: "识别要点",
            text: data.discern,
          },
        ];

        this.disease = [
          {
            name: "农业防治建议",
            text: data.geoponicsControl,
          },
          {
            name: "化学防治",
            text: data.chemistryControl,
          },
        ];
        this.cropObject = res.data.information;
        this.crop = res.data.information.formulaCropEntity;
        document.getElementsByTagName('title')[0].innerHTML = this.cropObject.cropName+this.cropObject.name;

        this.$axios
          .get(
            `post/findWebsitePdGallery?cropId=${data.cropId}&pageSize=6&pageNum=1`
          )
          .then((re) => {
            let data = re.data;
            let list = [];
            data.information.list.map(v=>{
              if(v.galleryId!=this.id){
                list.push(v)
              }
            })
            this.aboutR = list;
          });
      });

    this.$axios
      .get(
        `post/findArticleList?articleAreaId=&userId=1&pageSize=10&pageNum=1&randStatus=1`
      )
      .then((data) => {
        data = data.data;
        this.totalpage = data.information.articleList.total;
        // this.articleList = data.information.articleList.list.map((v) => {
        //   return {
        //     title: `【${v.areaName}】${v.subject}`,
        //     desc: v.contentStr.replace(/&nbsp;/g, ""),
        //     author: v.name,
        //     time: v.recoverDate,
        //     clickViews: v.clickViews,
        //     imgUrl: v.coverImg,
        //     link: `njzsxq.html?id=${v.researchId}`,
        //   };
        // });
        this.cardList = data.information.randArticleList;
        this.loading = false;
      });
  },
  methods: {
    pageChange(n) {
      console.log(n);
      this.loading = true;
      this.$axios
        .post(
          `https://m.nongjike.cn/app/community/findComment?userId=1&id=${this.id}&pageNum=${n}&pageSize=10`
        )
        .then((res) => {
          this.comments = res.data.information.list;
          this.loading = false;
          //   this.totalpage = res.data.information.total
        });
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
video {
  width: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}
.crop-title {
  font-size: 24px;
  color: #1f1f1f;
  padding-top: 20px;
  text-align: center;
  margin-bottom: 12px;
}
.crop-times {
  padding-bottom: 40px;
}
.crop-infos {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 22px;
  .crop-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    color: #999;
    font-size: 14px;
    margin-left: 8px;
    line-height: 22px;
    .iconfont {
      color: #999;
      font-size: 16px;
      margin-right: 4px;
    }
  }
}
.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.research-links {
  margin: 40px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .research-link {
    width: 45%;
    text-align: left;
    vertical-align: bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
    a {
      color: #333;
      font-size: 16px;
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
      margin-right: 54px;
    }

    .likeList {
      width: 360px;
    }
  }
}

.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 22px 0;
  img {
    max-width: 100%;
    display: block;
    width: 100%;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
}
.crop-title {
  font-size: 24px;
  color: #1f1f1f;
  padding-top: 20px;
  text-align: center;
  margin-bottom: 12px;
}
.crop-times {
  padding-bottom: 40px;
}
.crop-infos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  .crop-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    color: #999;
    font-size: 14px;
    margin-left: 8px;
    line-height: 20px;
    margin-right: 15px;
    .iconfont {
      font-size: 16px;
      margin-right: 4px;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    .articleList{
      margin-right: 0;
      padding: 0 10px;
    }
  }
}
</style>
